import type { CancelablePromise } from '/src/api';
import { OpenAPI, request as __request } from '/src/api';
import { TAlertId } from '/src/lib/models';
import {
  TGetAlertResponse,
  TListAlertsRequest,
  TListAlertsResponse,
  TUpdateAlertRequest,
  TUpdateAlertResponse,
} from '/src/lib/types';

export class AlertService {
  /**
   * List Alerts
   * @returns Alert[]
   * @throws ApiError
   */
  public static async query(req?: TListAlertsRequest): CancelablePromise<TListAlertsResponse> {
    return await __request(OpenAPI, {
      method: 'GET',
      url: '/alerts',
      query: req,
    });
  }

  /**
   * Get Alert
   * @param id TAlertId
   * @returns Alert
   * @throws ApiError
   */
  public static async get(id: TAlertId): CancelablePromise<TGetAlertResponse> {
    return await __request(OpenAPI, {
      method: 'GET',
      url: '/alerts/{id}',
      path: { id },
    });
  }

  /**
   * Update Alert
   * @param id TAlertId
   * @param req TUpdateAlertRequest
   * @returns Alert
   * @throws ApiError
   */
  public static async update(id: TAlertId, req: TUpdateAlertRequest): CancelablePromise<TUpdateAlertResponse> {
    return await __request(OpenAPI, {
      method: 'PUT',
      url: '/alerts/{id}',
      path: { id },
      body: req,
    });
  }
}
